import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'; import BASE_API_URL from 'const';
import CorcSelect from 'components/utils/CorcSelect';

function StudyVars(props) {
    const [isAdd, setIsAdd] = useState(false);
    const [study, setStudy] = useState({
        'id': 0,
        'status': '',
        'acronym': '',
        'full_name': '',
        'start_date': '',
        'end_date': '',
        'description': '',
        'select_patient_eye': false,
        'patient_details': '',
        'patient_card_vars': [],
        'protocol_num': '',
        'corc_num': '',
        'exams': [],
        'scheduled_visits': [],
        'notifications': [],
        'technician_form_vars': [],
        'grading_vars_labels': [],
    });
    //const [examTypes, setExamTypes] = useState([])
    const [notificationTypes, setNotificationTypes] = useState([])

    const handleSubmit = e => {
        e.preventDefault();
        submitStudy();
    }

    const submitStudy = async (e) => {
        const changesToSave = ['id', 'notifications', 'exams', 'patient_card_vars', 'grading_vars_labels'];

        const changedStudy = JSON.parse(JSON.stringify(study));
        const errMsg = "Sorry, something went wrong when saving this study. Please contact your IT helpdesk.";

        let i;
        for (i in changedStudy) {
            if (changedStudy.hasOwnProperty(i) && !changesToSave.includes(i)) {
                delete changedStudy[i];
            }
        }

        let newPatientVarsNotification = patientVarsNotifications;
        if (changedStudy.hasOwnProperty("patient_card_vars")) {
            const selectedVars = patientVarsNotifications.map((v) => v.patient_card_var_id);
            for (let i = 0; i < changedStudy.patient_card_vars.length; i++) {
                if (!selectedVars.includes(changedStudy.patient_card_vars[i].id)) {
                    newPatientVarsNotification.push({
                        patient_card_var_id: changedStudy.patient_card_vars[i].id,
                        study_id: changedStudy.id,
                        send_email: false,
                    });
                }
            }
        }

        props.setOverlayVisible((count) => count + 1);

        await axios.patch(
            `${BASE_API_URL}/studies/${props.match.params.id}/`,
            {
                ...changedStudy,
                patient_card_vars_notifications: newPatientVarsNotification,
                patient_identifier: patientIdentifierId,
                grading_vars_labels: study.grading_vars_labels,
            },
            { withCredentials: true }
        )
            .then((response) => {
                props.setOverlayVisible((count) => count - 1);
                if (response.status === 200) {
                    props.history.push("/studies");
                } else {
                    alert(errMsg);
                }
            }, (error) => {
                console.error(error);
                alert(errMsg);
                props.setOverlayVisible((count) => count - 1);
            });
    };

    /*
     *  Patient Vars
     * */
    const [patientVars, setPatientVars] = useState([]);
    const [patientVarsNotifications, setPatientVarsNotifications] = useState([]);
    const [tmpPatientVars, setTmpPatientVars] = useState([]);
    const [currentExam, setCurrentExam] = useState({});
    const [patientIdentifierId, setPatientIdentifierId] = useState(null);

    /*
     *  Popups
     * */
    const [patientVarsPopupVisible, setPatientVarsPopupVisible] = useState(false);
    const [examVarsPopupVisible, setExamVarsPopupVisible] = useState(false);
    const [graderVariablesPopupVisible, setGraderVariablesPopupVisible] = useState(false);

    const [allTechFormVarsSelected, setAllTechFormVarsSelected] = useState(false);
    const [variablesLabelsGroups, setVariablesLabelsGroups] = useState([]);

    useEffect(function () {
        const getNotificationTypes = async () => {
            props.setOverlayVisible((count) => count + 1);

            await axios.get(BASE_API_URL + '/settings/notificationtypes/', { withCredentials: true }).then(response => {
                props.setOverlayVisible((count) => count - 1);
                if (response.status === 200) {
                    setNotificationTypes(response.data);
                }
            }, (error) => {
                props.setOverlayVisible((count) => count - 1);
                if (error.response.status === 401) {
                    props.resetAuth();
                    props.history.push('/login');
                }
            });
        }

        const getPatientVars = async () => {
            props.setOverlayVisible((count) => count + 1);

            await axios.get(BASE_API_URL + '/settings/patientcardvars/', { withCredentials: true }).then(response => {
                props.setOverlayVisible((count) => count - 1);
                if (response.status === 200) {
                    setPatientVars(response.data);
                }
            }, (error) => {
                props.setOverlayVisible((count) => count - 1);
                if (error.response.status === 401) {
                    props.resetAuth();
                    props.history.push('/login');
                }
            });
        }

        const getStudy = async () => {
            props.setOverlayVisible((count) => count + 1);

            if (props.match.params.id) {
                await axios.get(BASE_API_URL + '/studies/' + props.match.params.id + '/summary/', { withCredentials: true }).then(response => {
                    props.setOverlayVisible((count) => count - 1);
                    if (response.status === 200) {
                        // if we user is a monitor, we need to "close" this study
                        if (props.userAuth.user.role === 'monitor') {
                            response.data.status = 'closed';
                        }
                        setStudy(response.data);

                        if (
                            response.data.hasOwnProperty("patient_card_vars_notifications")
                            && response.data.patient_card_vars_notifications.length
                        ) {
                            setPatientVarsNotifications(response.data.patient_card_vars_notifications);
                        }
                    }
                }, (error) => {
                    props.setOverlayVisible((count) => count - 1);
                    if (error.response.status === 401) {
                        props.resetAuth();
                        props.history.push('/login');
                    }
                });
            }
        }

        if (props.userAuth.user.role !== 'admin') {
            props.history.push('/studies');
            return;
        }

        if (props.location.state && props.location.state.hasOwnProperty("isAdd") && props.location.state.isAdd) {
            setIsAdd(true);
            props.history.replace({
                pathname: props.location.pathname,
                state: {}
            });
        }


        getStudy();
        //getExamTypes();
        getNotificationTypes();
        getPatientVars();
        props.setNavLinks([{ title: 'Studies', url: '/studies/', icon: 'studies' }, { title: 'Create Study', url: '/studies/' + props.match.params.id, icon: 'study-details' }]);
    }, []);

    return (
        <div className="home_header_container_class">
            <div className="content">
                <div className="main-form">
                    <form onSubmit={handleSubmit} action="">
                        <div className="overview">
                            <h2 className="text-shadow">Notifications</h2>
                        </div>
                        <StudyVarsNotifications
                            study={study}
                            setStudy={setStudy}
                            notificationTypes={notificationTypes}
                            setNotificationTypes={setNotificationTypes}
                        />
                        <br />

                        <div className="form-group">
                            <StudyVarsPatientSection
                                key={1}
                                setPatientVarsPopupVisible={setPatientVarsPopupVisible}
                                study={study}
                                setStudy={study}
                                patientVars={patientVars}
                                setTmpPatientVars={setTmpPatientVars}
                            />
                            <StudyVarsTechnicianSection
                                key={2}
                                study={study}
                                setCurrentExam={setCurrentExam}
                                setExamVarsPopupVisible={setExamVarsPopupVisible}
                            />
                            <GraderVariablesSection
                                key={3}
                                study={study}
                                setCurrentExam={setCurrentExam}
                                setGraderVariablesPopupVisible={setGraderVariablesPopupVisible}
                            />
                        </div>

                        {study.status === "open" ? (
                            <StudyFormControlsOpen isAdd={props.isAdd} submitStudy={props.submitStudy} />
                        ) : (
                            <StudyFormControlsClosed study={study} />
                        )}

                    </form>
                </div>
                {patientVarsPopupVisible && (
                    <StudyVarsPatientPopup
                        setPatientVarsPopupVisible={setPatientVarsPopupVisible}
                        patientVars={patientVars}
                        setPatientVars={setPatientVars}
                        study={study}
                        setStudy={setStudy}
                        tmpPatientVars={tmpPatientVars}
                        setTmpPatientVars={setTmpPatientVars}
                        patientVarsNotifications={patientVarsNotifications}
                        setPatientVarsNotifications={setPatientVarsNotifications}
                        setPatientIdentifierId={setPatientIdentifierId}
                    />
                )}

                {examVarsPopupVisible && (
                    <StudyVarsExamPopup
                        setExamVarsPopupVisible={setExamVarsPopupVisible}
                        currentExam={currentExam}
                        setCurrentExam={setCurrentExam}
                        study={study}
                        setStudy={setStudy}
                        allTechFormVarsSelected={allTechFormVarsSelected}
                        setAllTechFormVarsSelected={setAllTechFormVarsSelected}
                    />
                )}
                {graderVariablesPopupVisible && (
                    <GraderVariablesPopup
                        study={study}
                        setStudy={setStudy}
                        currentExam={currentExam}
                        setCurrentExam={setCurrentExam}
                        setPopupVisible={setGraderVariablesPopupVisible}
                        labelsGroups={variablesLabelsGroups}
                        setLabelsGroups={setVariablesLabelsGroups}
                    />
                )}
            </div> {/* .content */}
        </div>
    );
}

export default StudyVars;

function StudyFormControlsOpen(props) {

    return (

        <div className="form-actions" style={{ float: "right" }}>
            {props.isAdd === true ? (
                <input type="submit" onClick={props.submitStudy} name="" className="btn normal orange align-center left" value="Save and Finish" />
            ) : (
                <React.Fragment>
                    <Link to="/studies" className="btn normal grey align-center left">Cancel</Link>
                    <input type="submit" onClick={props.submitStudy} name="" className="btn normal orange align-center left" value="Save" />
                </React.Fragment>
            )}

        </div>
    )
}

function StudyFormControlsClosed(props) {
    return (

        <div className="form-actions" style={{ float: "right" }}>
            <Link to={"/studies/" + props.study.id} className="btn normal grey align-center left">Back</Link>
        </div>
    )
}


function StudyVarsExamPopup(props) {

    const examVarsClickHandler = (ev, formVar, type) => {
        let editedExam = JSON.parse(JSON.stringify(props.currentExam));

        if (props.study.status !== "open") {
            return;
        }


        let found = false;
        for (let i = 0, len = editedExam.technician_form_vars.length; i <= len - 1; ++i) {
            let studyFormVar = editedExam.technician_form_vars[i];
            if (studyFormVar.technician_form_var.id === formVar.id) {
                found = true;
                if (type === 'var') {
                    editedExam.technician_form_vars.splice(i, 1);
                }
                else if (type === 'notification') {
                    studyFormVar.send_email = !studyFormVar.send_email;
                }
                break;
            }
        }

        if (!found) {
            editedExam.technician_form_vars.push({ technician_form_var: { id: formVar.id }, send_email: (type === 'notification') });
        }

        props.setCurrentExam(editedExam);
    };

    const saveExamVarsPopup = () => {
        let editedExams = JSON.parse(JSON.stringify(props.study.exams));
        let currExam = JSON.parse(JSON.stringify(props.currentExam));
        for (let i = 0, len = editedExams.length; i <= len - 1; ++i) {
            if (editedExams[i].id === currExam.id) {
                editedExams.splice(i, 1, currExam);
                break;
            }
        }

        props.setStudy({ ...props.study, exams: editedExams });
        props.setCurrentExam({});
        props.setExamVarsPopupVisible(false);
    };

    const closeExamVarsPopup = () => {
        props.setExamVarsPopupVisible(false);
        props.setCurrentExam({});
    };

    const isCheckedVar = (exam, formVar, type) => {

        let isChecked = false;
        exam.technician_form_vars.map(studyFormVar => {
            if (type === 'var' && studyFormVar.technician_form_var.id === formVar.id) {
                isChecked = true;
            }
            else if (type === 'notification' && studyFormVar.technician_form_var.id === formVar.id && studyFormVar.send_email) {
                isChecked = true;
            }
            return false;
        });

        return isChecked;
    };

    const loadVars = (type) => {
        let vars = [];

        props.currentExam && props.currentExam.exam_type.technician_form_vars.map((formVar, i) => {
            if (formVar.group === type) {
                vars.push([
                    <li key={i}>
                        <button
                            className={"btn xsmall grey left check-var" + (isCheckedVar(props.currentExam, formVar, 'var') ? "" : " unchecked")}
                            onClick={(ev) => examVarsClickHandler(ev, formVar, 'var')}
                        >
                            <span className="icon-list report" style={{ marginLeft: "0" }}></span>
                        </button>

                        <button
                            className={"btn xsmall grey left check-var" + (isCheckedVar(props.currentExam, formVar, 'notification') ? "" : " unchecked")}
                            onClick={(ev) => examVarsClickHandler(ev, formVar, 'notification')}
                        >
                            <span className="icon-list notification" style={{ marginLeft: "0" }}></span>
                        </button>
                        <span> {formVar.name}</span>
                    </li>
                ]);
            }
            return false;
        });

        return vars;
    };

    const selectAllTechFormVars = selectAll => {
        let editedExam = JSON.parse(JSON.stringify(props.currentExam));

        editedExam.technician_form_vars = []
        if (selectAll) {
            editedExam && editedExam.exam_type.technician_form_vars.forEach((formVar, i) => {
                editedExam.technician_form_vars.push({ technician_form_var: { id: formVar.id }, send_email: true });
            });
        }

        props.setCurrentExam(editedExam);
        props.setAllTechFormVarsSelected(selectAll);
    };

    const isAllSelected = () => {
        if (props.currentExam) {
            let found = props.currentExam.technician_form_vars.find(f => f.technician_form_var.send_email === false);
            if (found) {
                props.setAllTechFormVarsSelected(false);
                return true;
            }

            if (props.currentExam.technician_form_vars.length === props.currentExam.exam_type.technician_form_vars.length) {
                props.setAllTechFormVarsSelected(true);
                return true;
            }

            props.setAllTechFormVarsSelected(false);
            return true;
        }
    };
    isAllSelected();

    return (
        <React.Fragment>
            <div className="modal fade in" style={{ width: "943px", left: "35.2%" }}>
                <div className="modal-header">
                    <h3>
                        Technician submissions forms: Customize {props.currentExam.exam_type.name}
                        <button
                            className="btn grey small"
                            style={{ float: "right" }}
                            onClick={() => selectAllTechFormVars(!props.allTechFormVarsSelected)}
                        >{props.allTechFormVarsSelected ? 'Unselect all' : 'Select all'}</button>
                    </h3>

                </div> {/* .modal-header */}

                <div className="modal-body">
                    <ul className="customize-vars">
                        <li className="title">General Vars</li>
                        {loadVars('general')}
                    </ul>

                    <ul className="customize-vars">
                        <li className="title">Other Vars</li>
                        {loadVars('other')}
                    </ul>
                </div>

                <div className="modal-footer">
                    {props.study.status === "open" && (
                        <button
                            onClick={saveExamVarsPopup}
                            className="btn orange align-center right normal"
                        >Save and Close
                        </button>
                    )}
                    <button
                        onClick={closeExamVarsPopup}
                        className="btn grey align-center right normal"
                    >Cancel and Close
                    </button>
                </div>
            </div>

            <div className="modal-backdrop fade in"></div>
        </React.Fragment>

    );
}

function GraderVariablesPopup(props) {
    const default_options_small = [
        {
            id: "none",
            label: "N/A",
            order: 0,
        },
        {
            id: "adequate",
            label: "Adequate",
            order: 1,
        },
        {
            id: "notadequate",
            label: "Not adequate",
            order: 2,
        },
    ];

    const default_options_medium = [
        {
            id: "none",
            label: "N/A",
            order: 0,
        },
        {
            id: "good",
            label: "Good",
            order: 1,
        },
        {
            id: "acceptable",
            label: "Acceptable",
            order: 2,
        },
        {
            id: "poor",
            label: "Poor",
            order: 3,
        },
    ];

    const default_groups = [
        {
            id: "file_labelling",
            label: "File Labelling",
            options: default_options_small,
        },
        {
            id: "protocol_procedures",
            label: "Protocol Procedures",
            options: default_options_small,
        },
        {
            id: "photo_fields",
            label: "Photographic Fields",
            options: default_options_small,
        },
        {
            id:"photo_quality",
            label: "Photographic Quality",
            options: default_options_medium,
        },
        {
            id: "quality",
            label: "Quality",
            options: default_options_medium,
        },
    ];

    const initial_state = default_groups
        .filter((group) => {
            const allowed_groups = ["protocol_procedures", "file_labelling"];
            const key = `include_${group.id}`;
            if (props.currentExam.exam_type[key] || allowed_groups.includes(group.id)) {
                return true;
            }
            return false;
        })
        .flatMap((group) => {
            return group.options.map((option) => ({
                label: option.label,
                option: option.id,
                variable: group.id,
                order: option.order,
                study_id: props.study.id,
                study_exam_id: props.currentExam.id,
            }));
        });

    useEffect(() => {
        let updated_groups = props.labelsGroups;

        initial_state.forEach((x) => {
            if (!updated_groups.some(
                (g) => g.variable === x.variable &&
                    g.option === x.option &&
                    g.study_exam_id === x.study_exam_id
            )) {
                updated_groups.push(x);
            }
        });

        if (
            props.study !== undefined &&
            props.study.grading_vars_labels !== undefined &&
            props.study.grading_vars_labels.length > 0
        ) {
            updated_groups = updated_groups.map((group) => {
                let match = props.study.grading_vars_labels.find(
                    (x) => x.option === group.option &&
                        x.variable === group.variable &&
                        x.study_exam_id === group.study_exam_id
                );
                return match !== undefined ? match : group;
            });
        }

        props.setLabelsGroups([...updated_groups]);
    }, []);

    const closePopup = () => {
        props.setPopupVisible(false);
        props.setCurrentExam({});
    };

    const savePopup = () => {
        props.setStudy({ ...props.study, grading_vars_labels: props.labelsGroups });
        closePopup();
    };

    const onChangeHandler = (event) => {
        const option = event.target.dataset.option;
        const variable = event.target.dataset.variable;
        const value = event.target.value;

        props.setLabelsGroups((groups) => {
            return groups.map((group) => {
                if (
                    group.option === option &&
                    group.variable === variable &&
                    group.study_exam_id === props.currentExam.id
                ) {
                    return {
                        ...group,
                        label: value,
                    };
                }
                return group;
            });
        });
    };

    const buildInput = (exam_id, variable, label, option) => {
        const title = default_groups
            .find((g) => g.id === variable).options
            .find((o) => o.id === option).label

        return (
            <div className="flex items-center" key={`${exam_id}-${variable}-${option}`}>
                <label htmlFor={`label[${variable}][${option}]`}>
                    {title}
                </label>
                <input
                    type="text"
                    value={label}
                    id={`label[${variable}][${option}]`}
                    name={`label[${variable}][${option}]`}
                    data-option={option}
                    data-variable={variable}
                    onChange={onChangeHandler}
                    className="w-full"
                />
            </div>
        );
    };

    const groupVariables = (result, current) => {
        (result[current.variable] = result[current.variable] || []).push(current);
        return result;
    };

    return (
        <React.Fragment>
            <div className="modal fade in" style={{ width: "943px", left: "35.2%" }}>
                <div className="modal-header">
                    <h3>Grading Variables: Customize {props.currentExam.exam_type.name} labels</h3>
                </div>

                <form id="grading_vars_labels">
                    <div className="modal-body">
                        <div className="grid grid-cols-3 gap-4">
                            {Object.entries(
                                props.labelsGroups
                                    .filter((x) => x.study_exam_id === props.currentExam.id)
                                    .reduce(groupVariables, [])
                            )
                            .map(([k, v]) => ({ variable: k, options: v }))
                            .map((group) => (
                                <React.Fragment key={group.variable}>
                                    <div className="flex flex-col customize-grader-labels gap-y-2">
                                        <h4 className="pb-2">
                                            {default_groups.find((g) => g.id === group.variable).label}
                                        </h4>
                                        {group.options.map((o) => buildInput(o.study_exam_id, o.variable, o.label, o.option))}
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </form>

                <div className="modal-footer">
                    {props.study.status === "open" && (
                        <button
                            onClick={savePopup}
                            className="btn orange align-center right normal"
                        >
                            Save and Close
                        </button>
                    )}
                    <button
                        onClick={closePopup}
                        className="btn grey align-center right normal"
                    >
                        Cancel and Close
                    </button>
                </div>
            </div>

            <div className="modal-backdrop fade in"></div>
        </React.Fragment>
    );
}

function StudyVarsTechnicianSection(props) {

    const showExamVarsPopup = (e, exam) => {
        e.preventDefault();
        props.setCurrentExam(JSON.parse(JSON.stringify(exam)));
        props.setExamVarsPopupVisible(true);
    }


    return (
        <div className="study-vars-group">
            <h2 className="text-shadow">Technicians submissions forms:</h2>
            <br />
            {props.study.exams && props.study.exams.map((exam, i) => (
                <button
                    key={i}
                    className="btn large grey align-center left customize-vars"
                    onClick={(e) => showExamVarsPopup(e, exam)}
                >{exam.exam_type.name}
                </button>
            ))}
        </div>
    );
}

function StudyVarsPatientSection(props) {
    const showPatientVarsPopup = (e) => {
        e.preventDefault();
        let tPVars = props.study.patient_card_vars.slice();

        props.setTmpPatientVars(tPVars);
        props.setPatientVarsPopupVisible(true);
    }

    return (
        <div className="study-vars-group">
            <h2 className="text-shadow">
                Patient Card Information:
            </h2>
            <br />
            <button
                className="btn large grey align-center left customize-vars"
                onClick={(e) => showPatientVarsPopup(e)}
            >Customize Patient Card
            </button>
        </div>
    );
}

function GraderVariablesSection(props) {
    const showPopup = (event, exam) => {
        event.preventDefault();
        props.setCurrentExam(JSON.parse(JSON.stringify(exam)));
        props.setGraderVariablesPopupVisible(true);
    }

    return (
        <div className="study-vars-group">
            <h2 className="text-shadow">
                Grading variables labels:
            </h2>
            <br />
            {
                props.study.exams !== undefined &&
                props.study.exams.length > 0 &&
                props.study.exams.map((exam) => (
                    <button
                        key={exam.id}
                        className="btn large grey align-center left customize-vars"
                        onClick={(e) => showPopup(e, exam)}
                    >
                        {exam.exam_type.name}
                    </button>
                ))
            }
        </div>
    );
}

function StudyVarsPatientPopup(props) {
    useEffect(() => {
        // Set the _default_ vars
        if (
            props.study.patient_identifier === null &&
            props.tmpPatientVars.filter((v) => v.group === "general").length === 0
        ) {
            // setting the default patient card vars for studies without them
            // hedious code ahead, sorry, no other way to do this
            const default_vars = props.patientVars.filter((v) => {
                switch (v.uid) {
                    case "patient-number":
                    case "comments":
                    case "basal-date":
                        return true;
                    case "study-eye":
                        return props.study.select_patient_eye;
                    default:
                        return false;
                }
            });

            props.setTmpPatientVars((vars) => [
                ...vars,
                ...default_vars,
            ]);

            // remove basal-date from notifications
            const default_vars_copy = default_vars.filter((v) => v.uid !== "basal-date");
            let default_notifications_vars = [];
            for (let i=0; i<default_vars_copy.length; ++i) {
                default_notifications_vars.push({
                    patient_card_var_id: default_vars_copy[i].id,
                    study_id: props.study.id,
                    send_email: true,
                });
            }
            props.setPatientVarsNotifications(default_notifications_vars);
        }
    }, []);

    const isPatientCardInStudy = (pVar) => {
        let item = props.tmpPatientVars.find((p) => {
            return p.id === pVar.id;
        });

        if (item !== undefined) {
            return true;
        }

        return false;
    };

    const patientVarClickHandler = (pVar) => {
        let found = false;
        let editPVars = props.tmpPatientVars.slice();

        if (props.study.status !== "open") {
            return;
        }

        for (var i = 0; i < editPVars.length; ++i) {
            // if we find the patient card var, lets remove it
            if (editPVars[i].id === pVar.id) {
                // Don't remove study eye if the study has select_patient_eye
                if (pVar.uid === "study-eye" && props.study.select_patient_eye) {
                    break;
                }

                editPVars.splice(i, 1);
                found = true;

                let patientVarNotification = props.patientVarsNotifications.find((v) => v.patient_card_var_id === pVar.id);
                if (patientVarNotification && patientVarNotification.send_email) {
                    props.setPatientVarsNotifications((currentVars) => {
                        return currentVars.map((v) => {
                            if (v.patient_card_var_id === patientVarNotification.patient_card_var_id) {
                                return {
                                    ...patientVarNotification,
                                    send_email: false,
                                };
                            }
                            return v;
                        });
                    });
                }

                break;
            }
        }

        // lets add the patient card var
        if (!found) {
            editPVars.push(pVar);
        }

        props.setTmpPatientVars(editPVars);
    };

    const savePatientVarsPopup = () => {
        let newPVars = props.tmpPatientVars.slice();
        props.setTmpPatientVars([]);
        props.setStudy({ ...props.study, patient_card_vars: newPVars });
        props.setPatientVarsPopupVisible(false);
    };

    const closePatientVarsPopup = () => {
        props.setTmpPatientVars([]);
        props.setPatientVarsPopupVisible(false);
    };

    const isPatientCardVarNotificationSet = (notificationVar) => {
        if (props.patientVarsNotifications.length > 0) {
            let item = props.patientVarsNotifications.find((v) => {
                return v.patient_card_var_id === notificationVar.id;
            });
            return item && item.send_email;
        }
        return false;
    };

    const patientCardVarNotificationClickHandler = (notificationVar) => {
        let found = false;

        if (props.study.status !== "open") {
            return;
        }

        if (!props.tmpPatientVars.find((v) => v.id === notificationVar.id)) {
            patientVarClickHandler(notificationVar);
        }

        let editedPatientVarsNotifications = props.patientVarsNotifications.map((v) => {
            if (v.patient_card_var_id === notificationVar.id) {
                found = true;
                return {
                    ...v,
                    send_email: !v.send_email,
                };
            }
            return v;
        });

        if (!found) {
            let pVar = props.patientVars.find((v) => v.id === notificationVar.id);
            if (pVar) {
                editedPatientVarsNotifications.push({
                    patient_card_var_id: notificationVar.id,
                    study_id: props.study.id,
                    send_email: true,
                });
            }
        }

        props.setPatientVarsNotifications(editedPatientVarsNotifications);
    };

    return (
        <React.Fragment>
            <div className="modal fade in" style={{ width: "943px", left: "35.2%" }}>
                <div className="modal-header">
                    <h3>Patient Card Information: Customize Patient Card</h3>
                </div> {/* .modal-header */}

                <div className="modal-body checkbox-group group-page">
                    <ul className="customize-vars">
                        <li className="title">General Vars</li>
                        {props.patientVars && props.patientVars.map((pVar, i) => pVar.group === 'general' && (
                            <li key={i}>
                                <button
                                    className={"btn xsmall grey left" + (isPatientCardInStudy(pVar) ? "" : " unchecked")}
                                    onClick={() => patientVarClickHandler(pVar)}
                                >
                                    <span className="icon-list report" style={{ marginLeft: "0" }}></span>
                                </button>
                                <button
                                    className={"btn xsmall grey left" + (isPatientCardVarNotificationSet(pVar) ? "" : " unchecked")}
                                    onClick={() => patientCardVarNotificationClickHandler(pVar)}
                                    disabled={pVar.admin_field}
                                >
                                    <span className="icon-list notification" style={{ marginLeft: "0" }}></span>
                                </button>
                                <span>
                                    {pVar.name}
                                    {pVar.admin_field && <span style={{ color: "red", fontSize: "10px", marginLeft: "4px" }}>(Admin)</span>}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <div style={{ overflow: "auto", width: "100%" }} />
                    <div style={{ display:"block", width: "100%", paddingTop: "8px" }}>
                        <label htmlFor="identifier-select" style={{ paddingLeft: "5px", paddingBottom: "4px" }}>
                            Patient Identifier Var *
                        </label>
                        <CorcSelect
                            id="identifier-select"
                            containerStyles={{ width: "200px", paddingTop: "3px" }}
                            name="identifier"
                            options={
                                props.tmpPatientVars
                                    .filter((pvar) => pvar.group === "general" && !pvar.admin_field && pvar.field_type === "input")
                                    .map((item) => ({ value: item.id, label: item.name}))
                            }
                            defaultValue={
                                props.study.patient_identifier === null ?
                                    false :
                                    {
                                        value: props.study.patient_identifier.id,
                                        label: props.study.patient_identifier.name
                                    }
                            }
                            onChange={(selectedOption) => props.setPatientIdentifierId(selectedOption.value)}
                            isSearchable={false}
                        />
                    </div>
                    <ul className="customize-vars">
                        <li className="title">Other Vars</li>
                        {props.patientVars && props.patientVars.map((pVar, i) => pVar.group === 'other' && (
                            <li key={i}>
                                <button
                                    className={"btn xsmall grey left" + (isPatientCardInStudy(pVar) ? "" : " unchecked")}
                                    onClick={() => patientVarClickHandler(pVar)}
                                >
                                    <span className="icon-list report" style={{ marginLeft: "0" }}></span>
                                </button>
                                <button
                                    className={"btn xsmall grey left" + (isPatientCardVarNotificationSet(pVar) ? "" : " unchecked")}
                                    onClick={() => patientCardVarNotificationClickHandler(pVar)}
                                >
                                    <span className="icon-list notification" style={{ marginLeft: "0" }}></span>
                                </button>
                                <span> {pVar.name}</span>
                            </li>
                        ))}
                    </ul>
                </div> {/* .modal-body */}

                <div className="modal-footer">
                    {props.study.status === "open" && (
                        <button
                            onClick={savePatientVarsPopup}
                            className="btn orange align-center right normal"
                        >Save and Close
                        </button>
                    )}
                    <button
                        onClick={closePatientVarsPopup}
                        className="btn grey align-center right normal"
                    >Cancel and Close
                    </button>
                </div>
            </div>

            <div className="modal-backdrop fade in"></div>
        </React.Fragment>
    );
}

function StudyVarsNotifications(props) {

    const isNotificationInStudy = (notification) => {

        let not = props.study.notifications.find((not) => {
            return not.id === notification.id;
        });

        if (not !== undefined) {
            return true;
        }

        return false;

    };

    const onNotificationChangeHandler = (ev, notification) => {

        let isChecked = ev.target.checked, notifications = props.study.notifications.slice();

        if (isChecked) {
            notifications.push(notification);
        }
        else {
            notifications = notifications.filter((not) => {
                return not.id !== notification.id;
            })
        }

        props.setStudy({ ...props.study, notifications: notifications });

    };

    return (
        <div className="form-group checkbox-group group-page">
            <div className="row notifications-group" style={{ paddingTop: "4px" }}>

                {props.notificationTypes.map((notification, i) => (
                    <div className="checkbox" key={i}>
                        <input
                            value={notification.id}
                            id={"notifications_" + notification.id}
                            name="notifications"
                            type="checkbox"
                            checked={isNotificationInStudy(notification)}
                            onChange={(e) => onNotificationChangeHandler(e, notification)}
                            disabled={props.study.status === "open" ? "" : "disabled"}
                        />
                        <label htmlFor={"notifications_" + notification.id}>{notification.name}</label>
                    </div>
                ))}

            </div>
        </div>
    );
}

